import { createI18n } from "vue-i18n";

import { config } from "@/config";

import { default as da } from "./locales/da.json";
import { default as de } from "./locales/de.json";
import { default as en } from "./locales/en.json";

export const i18n = createI18n({
  legacy: false,
  locale: config.app.language,
  fallbackLocale: ["en", "da"],
  messages: { da, de, en }
});
